<template>
    <div class="flex flex-col items-center justify-items-center lg:px-64 md:px-32 sm:px-16 px-3 mb-40">
        <h2 class="mt-16 mb-10 tracking-wider font-semibold text-center text-3xl">{{ $route.params.title }}</h2>
        <tailwind-image
            v-if="linkExists(0)"
            :link="links[0]"
            aspect-ratio="7/12"
            class="w-full"
        ></tailwind-image>
        <div class="mt-5">
            <p>Für ein norwegisches Unternehmen wurde ein neues Produktdesign und Hallenkonzept entwickelt. Es handelt sich dabei um das Design für eine Serie multifunktionaler Hallen, die überwiegend im Sport- und Kulturbereich eingesetzt werden. Das System erlaubt es, die Hallen in unterschiedlichen Größen zu realisieren, aber auch unterschiedliche Nutzungen sind denkbar. Die Ausstattung der Hallen kann individuell zusammengestellt werden. Design-Patente wurden angemeldet für Kanada, U.S.A. und Norwegen. Das Identität stiftende Design zeigt Anklänge an den Schiffsbau und zitiert damit die Herkunft und Historie des Unternehmens. Die asymmetrische Überhöhung der Tragstruktur und der ständige Wechsel von Hoch- und Tiefpunkten führt zu einer expressiven und dynamischen Gesamtform. Die zeitgenössische, biomorphe Formensprache entsteht aus dem Wechselspiel konkaver Membranflächen mit der konvexen Tragstruktur. </p>
        </div>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(1)"
                :link="links[1]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(2)"
                :link="links[2]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(3)"
                :link="links[3]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(4)"
                :link="links[4]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(5)"
                :link="links[5]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(6)"
                :link="links[6]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(7)"
                :link="links[7]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(8)"
                :link="links[8]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(9)"
                :link="links[9]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(10)"
                :link="links[10]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(11)"
                :link="links[11]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(12)"
                :link="links[12]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <tailwind-image
            v-for="iLink in allRemainingLinks"
            :key="'VueKey' + iLink"
            :link="iLink"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <span class="mt-5 w-full text-left">
            <p class="font-semibold">Entwurf</p>
            <p>Markus Holzbach Architektur</p>
            <p class="font-semibold">Tragwerk</p>
            <p>Patrick Teuffel</p>
        </span>

    </div>
</template>
<script>
import TailwindImage from '@/components/TailwindImage';


export default {
    components: {
        TailwindImage,
    },
    props: {},
    data ()
    {
        return {
            links: [
                require( '@/assets/img/pc/hinten nacht.jpg' ),
                require( '@/assets/img/pc/blau-grün fertig ausschnitt.jpg' ),
                require( '@/assets/img/pc/blau-grün fertig.jpg' ),
                require( '@/assets/img/pc/vorne tag.jpg' ),
                require( '@/assets/img/pc/Perspektive 7-31-07.jpg' ),
                require( '@/assets/img/pc/Perspektive 10-31-07.jpg' ),
                require( '@/assets/img/pc/Perspektive 11-31-07.jpg' ),
                require( '@/assets/img/pc/Perspektive 12-31-07.jpg' ),
                require( '@/assets/img/pc/Plan 0-1 Rendering.jpg' ),
                require( '@/assets/img/pc/Plan 0-2 Rendering.jpg' ),
                require( '@/assets/img/pc/Plan10.jpg' ),
                require( '@/assets/img/pc/visualisierung large outside.jpg' ),
                require( '@/assets/img/pc/visualisierung small inside.jpg' ),
                require( '@/assets/img/pc/vorne nacht.jpg' ),
            ],
        };
    },
    methods: {
        linkExists ( index )
        {
            return index in this.links;
        }
    },
    created () { },
    computed: {
        allRemainingLinks ()
        {
            if ( !this.linkExists( 13 ) )
            {
                return [];
            } else
            {
                return this.links.slice( 13 );
            }
        }
    }
};
</script>